import { Component } from "@angular/core";

@Component({
  selector: "app-careplus-reports",
  templateUrl: "./careplus-reports.component.html",
  styleUrls: ["./careplus-reports.component.css"],
})
export class CareplusReportsComponent {
  pageTitle = "Care+ Reports";
  constructor() {}

  ngOnInit() {}
}
